import styled from 'styled-components'
import { cyberColors } from '../../../../lib/colors'
import { Slider_style_props } from './interface'
const red = `linear-gradient(
  90deg,
  #ee3838 0%,
  #cf3333 82.29%,
  #802626 95.31%
)`
const blue = `linear-gradient(90deg, #1C2E75 0%, #355AEE 14.06%, #355AEE 100%)`

export const SliderWrapperNew = styled.div<Slider_style_props>`
  display: flex;
  align-items: center;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 40px;
  background: ${cyberColors.greyDark};
  padding: 0 18px;
  border-radius: 4px;
  margin-bottom: 15px;
  pointer-events: ${({ startAuto }) => startAuto && 'none'};
  opacity: ${({ startAuto }) => (startAuto ? 0.5 : 1)};
  cursor: ${({ startAuto }) => (startAuto ? 'not-allowed' : 'pointer')};
  transition: opacity 0.5s linear;
  .track {
    display: flex;
    width: 100%;
    height: 6px;
    width: calc(100% - 36px);
    position: absolute;
    top: 15px;
    pointer-events: none;
    border-radius: 8.16327px;
    z-index: 0;
  }
  .track-inner {
    width: 50%;
    height: 100%;
    background: ${({ rollUnder }) => (rollUnder ? '#545468' : red)};
    border: 1px solid ${({ rollUnder }) => (rollUnder ? '#363641' : '#622d32')};
    border-radius: 8.16327px;
    background-clip: content-box;
    z-index: 0;
  }
  .thumb {
    width: 28px;
    height: 28px;
    border: 0;
    z-index: 99 !important;
    cursor: pointer;
    transform: translateY(-11.5px) translateX(-50%);
    position: absolute;
    left: 50%;
    animation: ${({ anim }) => anim && 'scaleSVG'};
    animation-duration: 0.3s;
    animation-timing-function: cubic-bezier(0.39, 0.575, 0.565, 1);
    @keyframes scaleSVG {
      0% {
        transform: translateY(-11.5px) translateX(-50%) scale(1);
      }
      50% {
        transform: translateY(-11.5px) translateX(-50%) scale(1.2);
      }
      100% {
        transform: translateY(-11.5px) translateX(-50%) scale(1);
      }
    }
  }
  .value {
    position: absolute;
    height: 16px;
    padding: 0 2px;
    left: 50%;
    transform: translateY(-26px) translateX(-50%);
    font-size: 12px;
    background: ${cyberColors.greyDark};
    color: ${cyberColors.whiteText};
    border: 2px solid #35353f;
    border-radius: 4px;
    text-align: center;
    opacity: ${({ focus }) => (focus ? 1 : 0)};
    transition: opacity 0.5s linear;
    span {
      line-height: 1.2;
    }
  }
  .track-outter {
    width: 50%;
    height: 100%;
    border: 1px solid
      ${({ rollUnder }) => (rollUnder ? ' #2D3869 ' : '#363641')};
    border-radius: 8px;
    background: ${({ rollUnder }) => (rollUnder ? blue : '#545468')};
    background-clip: content-box;
    z-index: 2;
  }
  input {
    width: 100%;
    height: 6px;
    background: transparent;
    border-radius: 8.16327px;
    -webkit-appearance: none !important;
    z-index: 1;
    opacity: 0;
    &&:focus {
      outline: none;
    }
    ::-webkit-slider-runnable-track {
      -webkit-appearance: none;
    }
    ::-moz-slider-thumb {
      -moz-appearance: none;
    }
    ::-webkit-slider-thumb {
      width: 28px;
      height: 28px;
      border: 0;
      z-index: 99 !important;
      cursor: pointer;
      -webkit-appearance: none;
    }
  }
`
